<nav class="navbar navbar-dark bg-dark">
  <div class="container-fluid">
    <span class="navbar-brand mb-0 h1" routerLink="/list"
      >App Empleados - firebase</span
    >
  </div>
</nav>
